// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1hssj","header":"ReportDetails_header__3TkXI","title":"ReportDetails_title__HSK1u","left":"ReportDetails_left__22OcJ"};